<template>
  <div>

    <section class="hero is-medium is-warning" v-if="documentDeclined">
      <div class="hero-body">
        <p class="title">
          You have declined the document signing process.
        </p>
        <p class="subtitle">
          Please contact the agent.
        </p>
      </div>
    </section>

    <section class="hero is-medium is-warning" v-if="documentExpired">
      <div class="hero-body">
        <p class="title">
          This Document URL is expired you cannot continue the signing process.
        </p>
        <p class="subtitle">
          Please contact the agent.
        </p>
      </div>
    </section>

    <section class="hero is-medium is-warning" v-if="showDocumentAlreadySign">
      <div class="hero-body">
        <p class="title">
          This Document already signed.
        </p>
        <p class="subtitle">
          Please contact the agent.
        </p>
      </div>
    </section>

    <!--document remove modal-->
    <b-modal v-model="showRemoveDocumentModal" :width="400"  animation="zoom-out">
      <div class="model-card">

        <header class="modal-card-head">
          <p class="modal-card-title">Remove Document</p>
        </header>

        <div class="modal-card-body">
          <p>Are you sure you want to remove this document?</p>
          <div class="img-doc">
            <img src="../../../assets/icon/doc.png" alt="document-png" align="center">
          </div>

          <div style="margin-top: 40px">
            <b-button type="is-primary" outlined rounded expanded @click="removeDocument()">Remove</b-button>
          </div>
        </div>
      </div>
    </b-modal>



<!--<AddSignatureModal v-if="showAddSignatureModal && $route.params.document_id && $route.params.nic" @closeModal="showAddSignatureModal = false" @on-signature-added="getSignature"></AddSignatureModal>-->
    <AddSignatureModal v-if="showAddSignatureModal" @closeModal="showAddSignatureModal = false" @on-signature-added="getSignature"></AddSignatureModal>
    <EnterOTPModal v-if="showEnterOTPModal"></EnterOTPModal>
    <AddDateModal v-if="showAddDateModal"></AddDateModal>
    <SendSuccessModal v-if="showSendSuccessModal"></SendSuccessModal>

    <!--check route params is include document_id & nic-->
    <Documentview v-if="showDocument"></Documentview>

  </div>
</template>

<script>


import EnterOTPModal from '@/components/frontend/EnterOTPModal'
import AddDateModal from '@/components/frontend/AddDateModal'
import SendSuccessModal from "@/components/common/SendSuccessModal";
import Documentview from "@/components/frontend/Document";
import AddSignatureModal from "@/components/frontend/AddSignatureModal/AddSignatureModal";
import axios from "axios";

export default {
  name:'dashboard-view',

  components :{

    EnterOTPModal, // use inside add signature modal
    AddSignatureModal,
    AddDateModal,
    SendSuccessModal,
    Documentview,
  },

  beforeMount:function(){
    console.log("beforeMount called")

    window.$root = this.$root

    // load initial cutomer data
    this.setCustomerData()

    this.$root.invitee_token = this.$route.params.client_number
    this.$root.invitee_document_id = this.$route.params.document_id
    console.log('customer token - '+this.$root.invitee_token)


  },

  data(){
    return{
      recentDocs:[{id:1,value:'Doc'},{id:2,value:'Pdf'},{id:3,value:'Doc'}],
      labelPosition : "on-border",
      passwordConfirm :"",
      filUploadModal : false,

      showRemoveDocumentModal : false, // set true to test
      showAddSignatureModal :false, // set true to test


      showEnterOTPModal:false, // set true to test
      showAddDateModal:false, // set true to test

      showSendSuccessModal : false, // set true to test
      documentDeclined:false,
      documentExpired:false,
      showDocument:false,
      showDocumentAlreadySign:false,

    }
  },

  mounted() {
    const comp = this
      comp.getLocation()
      comp.getInviteeIP()
      comp.checkDocumentStatus()
      // comp.confirmCustomDelete()
  },

  methods:{

    AcceptDocument() {
      this.$buefy.dialog.confirm({
        title: ' Confirmation Message',
        message: 'Are you sure you want to <b>accept</b> signing process?',
        confirmText: 'Accept',
        cancelText:'Decline',
        type: 'is-danger',
        hasIcon: true,
        canCancel:true,
        onConfirm: () => this.acceptDocument(),
        onCancel:() => this.declineDocumentSign()
      })
    },

    checkDocumentLinkIsExpire: async function (){
      var comp = this

      try{
        let res = await axios({
          method: "post",
          url: comp.$base_url+'/customer/linkExpire',
          data: {
            document_id:comp.$root.invitee_document_id,
            client_number:comp.$route.params.client_number,
          },
        })

        console.log('is link expire-----------------');
        console.log(res.data)
        return res.data.linkExpire

      } catch(err){
        console.log(err)
      }
    },

    declineDocumentSign:function (){
      console.log('declined---------------');
      this.documentDeclined = true

      var component = this
      let formData = new FormData()
      formData.append('document_id',component.$root.invitee_document_id)
      formData.append('client_number',component.$route.params.client_number)

      axios.post(component.$base_url+'/customer/declineDocument', formData)
          .then(function (response){
            var arr = [];
            arr = response.data
            if(arr.success == true){
                console.log(response.data)
                component.documentDeclined =true

            }else{
              component.isSubmitting = false
              component.$buefy.toast.open({
                message: 'Something went wrong!',
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },

    acceptDocument:function (){

      var component = this
      let formData = new FormData()
      formData.append('document_id',component.$root.invitee_document_id)
      formData.append('client_number',component.$route.params.client_number)

      axios.post(component.$base_url+'/customer/acceptDocument', formData)
          .then(function (response){
            var arr = [];
            arr = response.data
            if(arr.success == true){
              console.log(response.data)
              component.showDocument = true

            }else{
              component.isSubmitting = false
              component.$buefy.toast.open({
                message: 'Something went wrong!',
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },

    checkDocumentStatus:async function () {
      var component = this
      var is_expire = await component.checkDocumentLinkIsExpire()

      if(is_expire == true){
        component.documentExpired = true
      }else{

       component.checkDocumentLink()
      }
    },

    checkDocumentLink:function (){
      var component = this

      let formData = new FormData()
      formData.append('document_id', component.$root.invitee_document_id)
      formData.append('client_number', component.$route.params.client_number)

      axios.post(component.$base_url + '/customer/checkDocumentLink', formData)
          .then(function (response) {
            var arr = [];
            arr = response.data
            if (arr.success == true) {
              console.log(response.data)
              arr = response.data.data

              if (arr.is_declined == 1) {  //check is document declined
                component.documentDeclined = true
              }
              if (arr.is_accept == 0 && arr.is_declined == 0) { //check is document accept and not declined
                component.AcceptDocument()
              }
              if(arr.is_accept ==1 && arr.link_expire == 0 && arr.is_signed == 0){ //check is accept the document and link is not expire
                component.showDocument =true
              }

              if(arr.is_signed == 1){  //check is signed document
                component.showDocumentAlreadySign = true
              }
            } else {
              component.isSubmitting = false
              component.$buefy.toast.open({
                message: 'Something went wrong!',
                type: 'is-danger'
              })
            }

          })
          .catch(function (error) {
            console.log(error);
          });
    },


    // use this method to define customer data
    setCustomerData : function(){
      this.$root.customerData = {
        name : "",              // use to store customer name
        // role : 'Lorem ips',     // use to store customer role
        role : 'Customer',     // use to store customer role
        nicNumber:'',           // use to store customer nic number
        email:'',           // use to store customer email
        contactNumber:'',           // use to store customer contact number
        nic_type:'',           // use to store customer nic type
        nicFrontImage : null,   // use to store customer's nic front image
        nicFrontImageURL : null,   // use to store customer's nic front image
        nicBackImage : null,    // use to store customer's nic back image
        nicBackImageURL : null,    // use to store customer's nic back image
        sealImage : null,       // use to store customer's seal or stamp image
        sealImageURL : null,       // use to store customer's seal or stamp image
        CustomerSignedIn:false  ,   //use to store customer signed it or no

      }
    },

    openFileUpload:function (){
      this.filUploadModal = true
    },

    removeDocument : function () {
      this.showRemoveDocumentModal = false
    },

    /**
     * this method is used to get returned signature from the signature modal
     * @param e returned signature
     */
    getSignature(e){
      const comp = this
      comp.getLocation()
      comp.getInviteeIP()
      if(e.signature){
        // TODO :: assign returned signature to the placeholder
        console.log("Signature received ------------ ")
        console.log(e.signature)
        comp.showAddSignatureModal = false
        console.log('signature data'+e.signature.verifiedSignatureData.signature_path)
        comp.ImgURL = e.signature.imageUrl
        comp.DbimgURl = e.signature.verifiedSignatureData.signature_path
      }
    },

    //get invitee's location
    getLocation:function (){
      var comp = this
      navigator.geolocation.getCurrentPosition(function(pos){

        comp.$root.location_data = {
          lat: pos.coords.latitude,
          lng: pos.coords.longitude,
          accuracy: pos.coords.accuracy
        }

        console.log(pos.coords)
      })
    },

    //get invitee's ip address
    getInviteeIP:function (){
      fetch('https://api.ipify.org?format=json')
          .then(x => x.json())
          .then(({ ip }) => {
            this.$root.invitee_ip_address = ip;
          });
    },

  }
}
</script>

  <style scoped>
  #dashboardItemTitle{
    color: #A5A6B3;
    font-weight: 600;
    font-size: 30px;
    text-align: left
  }
  .box{
    box-shadow: 0px 9px 17px rgba(0, 0, 0, 0.1);
    height: 100vh;
  }

  .card{
    background-color: #F2F4FF;
    height: 100%;
  }

  ul{
    list-style-type:none;
    margin-top: 10px;
  }

  .docCard{
    margin-top: 10px;
    border-radius: 10px;
    background-color: white;
    padding: 10px;
    box-shadow: -4px 4px 4px rgba(13, 93, 163, 0.09);
  }


  .upload-area img{
    opacity: 50%;
  }


  /* Signature modal styles */
  .item img{
    width: 60px;

  }

  .modal-card-title{
    font-weight: bold;
    background-color: #0D5DA3;
    font-size: 36px;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    padding-bottom: 5px;
  }





  </style>

